import { ITag } from "services/types";

export interface IExploreState {
  tags: ITag[];
  tagsLoading: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tagsError: any;
}

const defaultState = {
  tags: [],
  tagsLoading: false,
  tagsError: null,
};

export const getDefaultExploreState = () => defaultState;
